import React from "react";

// import { FilterCheckBox, FilterTabs, FilterRadio, FilterDate } from "../Filters";


export const FormButton = props => <>
  {props.button}
</>
